import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeQueryParams,
  webStorage,
} from 'sidecar-utility-library'

import { initialState, types } from './index'

export const fetchReviews = npi => ({
  [RSAA]: {
    endpoint: () => {
      const queryParams = makeQueryParams({
        page: 0,
        size: 25,
        npi,
      })

      return getApiPath(`doc`, `reviews${queryParams}`, 'v2')
    },
    method: 'GET',
    types: [
      types.FETCH_REVIEWS_REQUEST,
      types.FETCH_REVIEWS_SUCCESS,
      types.FETCH_REVIEWS_ERROR,
    ],
  },
})

export const flushDoctorReviews = () => ({
  type: types.FLUSH_DOCTOR_REVIEWS,
})

export const fetchMemberReview = npi => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `member-review${makeQueryParams({
        npi,
        memberUuid: webStorage.getItem('sub'),
      })}`,
      `v2`,
    ),
    method: 'GET',
    types: [
      types.FETCH_MEMBER_REVIEW_REQUEST,
      types.FETCH_MEMBER_REVIEW_SUCCESS,
      types.FETCH_MEMBER_REVIEW_ERROR,
    ],
  },
})

export const createReview = (npi, review) => {
  return {
    [RSAA]: {
      endpoint: getApiPath(`doc`, `reviews`, `v2`),
      method: 'POST',
      body: JSON.stringify({
        npi,
        memberUuid: webStorage.getItem('sub'),
        ...review,
      }),
      types: [
        types.CREATE_REVIEW_REQUEST,
        types.CREATE_REVIEW_SUCCESS,
        types.CREATE_REVIEW_ERROR,
      ],
    },
  }
}

export const updateReview = review => ({
  [RSAA]: {
    endpoint: getApiPath(`doc`, `reviews`, `v2`),
    method: 'PUT',
    body: JSON.stringify(review),
    types: [
      types.UPDATE_REVIEW_REQUEST,
      types.UPDATE_REVIEW_SUCCESS,
      types.UPDATE_REVIEW_ERROR,
    ],
  },
})

export const deleteReview = uuid => ({
  [RSAA]: {
    endpoint: getApiPath(`doc`, `reviews?uuid=${uuid}`, `v2`),
    method: 'DELETE',
    types: [
      types.DELETE_REVIEW_REQUEST,
      {
        type: types.DELETE_REVIEW_SUCCESS,
        meta: { uuid },
      },
      types.DELETE_REVIEW_ERROR,
    ],
  },
})

export const resetMemberReview = () => ({
  type: types.RESET_MEMBER_REVIEW,
})

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.FLUSH_DOCTOR_REVIEWS:
      return {
        ...state,
        reviews: initialState.reviews,
      }
    case types.FETCH_REVIEWS_REQUEST:
    case types.CREATE_REVIEW_REQUEST:
    case types.UPDATE_REVIEW_REQUEST:
    case types.DELETE_REVIEW_REQUEST: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_REVIEWS_SUCCESS: {
      const isLastPageReached = payload.page === payload.totalPages - 1
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: false,
          //Come back and check this for infinite loop
          entities: payload.content,
          isLastPageReached,
        },
      }
    }
    case types.FETCH_REVIEWS_ERROR:
    case types.CREATE_REVIEW_ERROR:
    case types.UPDATE_REVIEW_ERROR:
    case types.DELETE_REVIEW_ERROR: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    case types.FETCH_MEMBER_REVIEW_REQUEST: {
      return {
        ...state,
        memberReview: {
          ...state.memberReview,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_MEMBER_REVIEW_SUCCESS: {
      return {
        ...state,
        memberReview: {
          ...state.memberReview,
          busy: false,
          review: payload,
        },
      }
    }
    case types.FETCH_MEMBER_REVIEW_ERROR: {
      return {
        ...state,
        memberReview: {
          ...state.memberReview,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    case types.CREATE_REVIEW_SUCCESS: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: false,
          //Come back and check this for infinite loop
          entities: payload,
        },
      }
    }
    // ----------

    case types.UPDATE_REVIEW_SUCCESS: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: false,
          // loop over reviews and update the one that's updated.
          entities: state.reviews.entities.map(review =>
            review.uuid === payload.uuid ? payload : review,
          ),
        },
      }
    }
    // ----------

    case types.DELETE_REVIEW_SUCCESS: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          busy: false,
          // filter out the review that was deleted.
          entities: state.reviews.entities.filter(
            review => review.uuid !== meta.uuid,
          ),
        },
      }
    }
    // ----------

    case types.RESET_MEMBER_REVIEW: {
      return {
        ...state,
        memberReview: initialState.memberReview,
      }
    }

    // ----------

    default:
      return state
  }
}
